import { ValidationModalSubmitButton as ValidationModalSubmitButtonType } from '@/schemas/sceneDataSchema';
import { ComponentButton } from './ComponentButton';
import useAnalytics, { eventName } from '@/hooks/use-analytics';
import useModal from '@/hooks/use-modals';
import { useScopesValidity } from '@/hooks/use-entity-validity';
import type { MouseEvent } from 'react';

export const ValidationModalSubmitButton = ({ component }: { component: ValidationModalSubmitButtonType }) => {
  const { trackClick } = useAnalytics();
  const { getModal } = useModal();
  const scopesValidity = useScopesValidity(component.validation_scopes);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    trackClick(eventName(component.id), { button_type: component.type });

    if (scopesValidity === false) {
      event.preventDefault();
      getModal(component.modal_id)?.open();
    }
  };

  return (
    <ComponentButton
      form={component.form_id}
      component={component}
      type='submit'
      onClick={handleClick}
    />
  );
};
